import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Block from 'shopper/components/Block';

import GooglePublisherTagLandscapeAdSlot from 'components/AdSlots/GooglePublisherTagLandscapeAdSlot';
import LazyRenderer from 'components/LazyRenderer';

import useCommentIdFromRouterHash from 'hooks/useCommentIdFromRouterHash';

import COMMENT from 'constants/comment';

const OfferComments = dynamic(() => import('./OfferComments'), { ssr: false });

const DynamicallyLoadedOfferCommentsWithRef = forwardRef(
  ({ offer, offerKey, commentsSort, onCommentsSortChange }, ref) => {
    const { commentId, isValidCommentIdHashAvailable } =
      useCommentIdFromRouterHash();

    return (
      <>
        {/* Placeholder div to use its ref instead of
        `OfferComments` components if it is not loaded yet */}
        <Block ref={ref} />
        <LazyRenderer
          rootMargin="400px"
          force={isValidCommentIdHashAvailable}
          height={355}
        >
          <OfferComments
            commentIdFromUrlHash={commentId}
            commentsSort={commentsSort}
            offerKey={offerKey}
            onCommentsSortChange={onCommentsSortChange}
            {...offer}
          />
          <GooglePublisherTagLandscapeAdSlot
            adId="offer_page_main_content_1_320x50_468x60_728x90"
            adPath="/promobit.com.br_offer_page/main_content_1_320x50_468x60_728x90"
            mt={4}
          />
        </LazyRenderer>
      </>
    );
  }
);

DynamicallyLoadedOfferCommentsWithRef.displayName =
  'DynamicallyLoadedOfferCommentsWithRef';

DynamicallyLoadedOfferCommentsWithRef.defaultProps = {
  offer: null,
};

DynamicallyLoadedOfferCommentsWithRef.propTypes = {
  commentsSort: PropTypes.oneOf([...Object.values(COMMENT.SORT_VALUES)])
    .isRequired,
  offer: PropTypes.shape({
    isOfferCommentsAllowed: PropTypes.bool.isRequired,
    offerCommentsCount: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    offerId: PropTypes.number.isRequired,
    offerStatusName: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    reviews: PropTypes.array.isRequired,
  }),
  // `offerKey` is either `offerId` or an `offerSlug`
  offerKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  onCommentsSortChange: PropTypes.func.isRequired,
};

export default DynamicallyLoadedOfferCommentsWithRef;
